import React from "react";
import { ToastContainer } from "react-toastify";
import AllRoutes from "./routes/Routes";
import "react-toastify/dist/ReactToastify.css";

// For Default import Default.scss
import "./assets/scss/Default.scss";

// Other
import "./assets/scss/Landing.scss";
import "./assets/scss/Icons.scss";

const App = () => {
  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <AllRoutes />
      </React.Fragment>
    </>
  );
};

export default App;
